import { render, staticRenderFns } from "./KeywordChart.vue?vue&type=template&id=331f590c&scoped=true"
import script from "./KeywordChart.vue?vue&type=script&lang=js"
export * from "./KeywordChart.vue?vue&type=script&lang=js"
import style0 from "./KeywordChart.vue?vue&type=style&index=0&id=331f590c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f590c",
  null
  
)

export default component.exports